import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import LandingPage from './components/LandingPage';
import AdminRegister from './components/AdminRegister';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import AdminDashboard from './components/AdminDashboard';
import CreateUser from './components/CreateUser';
import CreateProfile from './components/CreateProfile';
import ProfileView from './components/ProfileView';
import EditProfile from './components/EditProfile';
import Templates from './components/Templates';
import AllProfiles from './components/AllProfiles';
import { AuthProvider, useAuth } from './context/AuthContext';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/login" />;
};

// Admin Only Route Component
const AdminRoute = ({ children }) => {
  const { isAuthenticated, user, loading } = useAuth();
  
  if (loading) {
    return (
      <div style={{ 
        minHeight: '100vh', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        background: '#f0f2f5'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div className="spinner"></div>
          <p style={{ marginTop: '20px', color: '#666' }}>Loading...</p>
        </div>
      </div>
    );
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }
  
  const userRole = user?.role || '';
  const isAdmin = userRole === 'superadmin' || userRole === 'admin' || 
                  userRole === 'Admin' || userRole === 'Superadmin';
  
  if (!isAdmin) {
    return <Navigate to="/dashboard" />;
  }
  
  return children;
};

// Dashboard Wrapper to check role and show appropriate dashboard
const DashboardWrapper = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ 
        minHeight: '100vh', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        background: '#f0f2f5'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div className="spinner"></div>
          <p style={{ marginTop: '20px', color: '#666' }}>Loading...</p>
        </div>
      </div>
    );
  }

  // Check if user is superadmin or admin
  const userRole = user?.role || '';
  const isAdmin = userRole === 'superadmin' || userRole === 'admin' || 
                  userRole === 'Admin' || userRole === 'Superadmin';

  if (user && isAdmin) {
    return <AdminDashboard />;
  }

  return <Dashboard />;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/register" element={<AdminRegister />} />
            <Route path="/login" element={<Login />} />
            <Route 
              path="/dashboard" 
              element={
                <ProtectedRoute>
                  <DashboardWrapper />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/create-user" 
              element={
                <AdminRoute>
                  <CreateUser />
                </AdminRoute>
              } 
            />
            <Route 
              path="/create-profile" 
              element={
                <ProtectedRoute>
                  <CreateProfile />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/profile/:username" 
              element={<ProfileView />} 
            />
            <Route 
              path="/edit-profile" 
              element={
                <ProtectedRoute>
                  <EditProfile />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/templates" 
              element={
                <ProtectedRoute>
                  <Templates />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/profiles" 
              element={
                <AdminRoute>
                  <AllProfiles />
                </AdminRoute>
              } 
            />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;

